import getCategoryForSrc from './getCategoryForSrc'


export default function setDataCategories(node, src = node.getAttribute('src')) {
  const category = getCategoryForSrc(src)

  node.setAttribute('data-categories', category)

  // We worked this category out from `src`, so it is only true of `src`. The
  // mark is what lets us start over when the element is pointed somewhere
  // else, and what keeps us off a category the site maintainer wrote.
  node.setAttribute('data-has-derived-categories', 1)
}
